<template>
  <v-overlay :value="loading" absolute>
    <div class="d-flex flex-column align-center justify-center">
      <v-progress-circular indeterminate size="64" :width="5" color="primary" />
      <span class="my-4 loading-text">{{ message || "กำลังโหลดข้อมูล" }}</span>
    </div>
  </v-overlay>
</template>

<script>
export default {
  name: "LoadingOverlay",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.loading-text {
  color: #fff;
  font-size: 16px;
  font-weight: 400;
}
</style>
